
<v-simple-table dense>
    <template v-slot:default>
        <tbody>
        <tr
            v-for="(entry, idx) in history" :key="idx"
        >
            <td class="pl-0 pr-0" style="width: 20px; text-align: left; "><i :class="entry.status.font + ' fa-' + entry.status.symbol "></i> </td>
            <td style="width: calc(43% - 20px);">{{ entry.status.name }}</td>
            <td style="width: 19%;">{{ format(entry.start) }}</td>
            <td style="width: 19%;">{{ format(entry.end) }}</td>
            <td style="width: 19%;">{{ diff(entry) }}</td>
        </tr>
        </tbody>
    </template>
</v-simple-table>
